import { Injectable, inject } from '@angular/core';
import { Observable, of, catchError } from 'rxjs';
import { ApiService } from './api.service';
import { PartnerInfo } from '../models';

/**
 * Partner Service - converted from PartnerDelegate.as
 *
 * REST API Methods:
 * - GET /partners/{id}
 * - GET /partners
 */
@Injectable({
  providedIn: 'root'
})
export class PartnerService {
  private readonly api = inject(ApiService);

  /**
   * Get partner info by ID
   */
  getPartner(partnerId: number): Observable<PartnerInfo | null> {
    if (!partnerId || partnerId === 0) return of(null);

    return this.api.get<PartnerInfo>('/partners/' + partnerId).pipe(
      catchError(err => {
        console.error('[PartnerService] getPartner error:', err);
        return of(null);
      })
    );
  }

  /**
   * List all active partners
   */
  getPartners(): Observable<PartnerInfo[]> {
    return this.api.get<PartnerInfo[]>('/partners').pipe(
      catchError(err => {
        console.error('[PartnerService] getPartners error:', err);
        return of([]);
      })
    );
  }
}
